import { render, staticRenderFns } from "./board.vue?vue&type=template&id=62b2041c&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"
import style0 from "./board.vue?vue&type=style&index=0&id=62b2041c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b2041c",
  null
  
)

export default component.exports